import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/ui/Button";

const NotFound = () => (
  <div className="flex flex-1 flex-col items-center justify-center px-6 py-16 text-center">
    <div className="text-7xl">🎣</div>
    <h1 className="mt-4 text-2xl font-bold text-slate-700">Ουπς!</h1>
    <p className="my-4 max-w-sm text-slate-500">
      Φαίνεται πως πέσαμε σε ένα άδειο ψαροκάικο! Η σελίδα που ψάχνετε είναι πιο ακριβή από τον καλύτερο τόνο της αγοράς!
    </p>
    <Link to="/">
      <Button>Γυρίστε πίσω στο λιμάνι</Button>
    </Link>
  </div>
);

export default NotFound;
